$(function(){
    $('.b-lang-select').each(function(){
        var $context = $(this),
            $langList = $('.b-lang-select__list', $context),
            $langItem = $('.b-lang-select__item', $context),
            $langLink = $('.b-lang-select__name', $context);

        $langLink.each(function(){
            $(this).on('click', function(e){
                if($(this).closest($langItem).is('.is-active')) {
                    e.preventDefault();
                    $langList.toggleClass('is-open');
                }
            });
        })
    })
});